import React from 'react';
import { TextArea } from 'cantarus-react-ui';
import { FieldDataStrings as Strings } from '../../../utils/config'

const FieldDataTextBox = ({ fieldName, fieldValue, handleFieldDataTextChange }) => {

    const onDataChange = (data) => {
        handleFieldDataTextChange(fieldName, data);
    }

    return (
        <TextArea
            label={Strings.header}
            rows={3}
            cols={60}
            onChange={onDataChange}
            value={(typeof fieldValue === 'string') ? fieldValue : ''}
            placeholder={Strings.placeholder}
        />
    );
}

export default FieldDataTextBox;
